export default __webpack_public_path__ + "static/media/12.709641b4.jpg";